var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDynamicCoronary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 75,
    viewBox: "0 0 91 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0406 67.9106H4.39045C4.09295 67.9106 3.79836 67.852 3.52351 67.7381C3.24865 67.6243 2.99891 67.4574 2.78854 67.2471C2.57817 67.0367 2.4113 66.787 2.29745 66.5121C2.1836 66.2373 2.125 65.9427 2.125 65.6452V3.52961C2.125 3.23211 2.18359 2.93751 2.29744 2.66266C2.41129 2.3878 2.57816 2.13805 2.78852 1.92769C2.99889 1.71732 3.24864 1.55045 3.52349 1.4366C3.79835 1.32275 4.09295 1.26416 4.39045 1.26416H73.8723C74.1698 1.26416 74.4644 1.32275 74.7393 1.4366C75.0141 1.55045 75.2639 1.71732 75.4743 1.92769C75.6846 2.13805 75.8515 2.3878 75.9653 2.66266C76.0792 2.93751 76.1378 3.23211 76.1378 3.52961L76.1377 17.955L76.1376 46.9131",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7773 8.45496H2.7002",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9209 19.1458C17.1286 25.2969 19.1643 26.4748 25.4242 26.7168C29.3041 27.745 35.2007 31.154 36.9318 34.8445C37.7503 36.7769 37.5931 38.9655 37.9504 41.0333C38.3076 43.1011 39.5178 45.3343 41.5902 45.6636",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4651 25.5289C16.8408 27.3753 15.7307 29.6164 15.2463 32.0274C14.7619 34.4384 14.9203 36.9343 15.7055 39.2648C16.1315 41.0462 16.7448 42.8718 16.3872 44.668",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7617 30.1654C20.8719 31.5168 22.1397 34.2643 24.5083 38.448",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1011 38.7561C12.5721 41.0272 10.0356 43.4303 9.4707 46.9498",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6306 43.4957C36.5768 45.5989 37.0574 48.4134 37.2926 51.0615",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8652 35.6091C40.5294 34.4875 42.2932 35.3945 44.281 36.3846C45.9238 37.2026 47.8134 37.3752 49.5773 36.8685C50.0891 36.7213 50.6003 36.5757 51.114 36.4729",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4229 35.3855C44.156 33.5411 45.451 31.9742 47.1244 30.9069",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4102 26.4699C30.71 21.2785 28.3244 18.8966 39.1168 19.9036",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5176 19.9523C33.5176 22.1458 35.7424 23.961 37.7129 25.0454C37.6598 25.0059 37.6067 24.9664 37.5536 24.9268",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2545 22.9592H53.3938C53.113 22.9592 52.8436 22.8476 52.6451 22.6491C52.4465 22.4505 52.335 22.1812 52.335 21.9004V17.7043C52.335 17.4235 52.4465 17.1542 52.6451 16.9556C52.8436 16.7571 53.113 16.6455 53.3938 16.6455H64.2545C64.5353 16.6455 64.8046 16.7571 65.0032 16.9556C65.2017 17.1542 65.3133 17.4235 65.3133 17.7043V21.9004C65.3133 22.0395 65.2859 22.1771 65.2327 22.3056C65.1795 22.4341 65.1015 22.5508 65.0032 22.6491C64.9049 22.7474 64.7882 22.8254 64.6597 22.8786C64.5312 22.9318 64.3935 22.9592 64.2545 22.9592Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4502 55.4583H17.5996",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4502 60.7197H22.3241",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1867 74.049H51.7589C51.2007 74.049 50.6654 73.8273 50.2708 73.4326C49.8761 73.0379 49.6543 72.5026 49.6543 71.9444V49.4951C49.6543 48.937 49.8761 48.4017 50.2708 48.007C50.6654 47.6123 51.2007 47.3905 51.7589 47.3905H87.1867C87.7449 47.3905 88.2802 47.6123 88.6749 48.007C89.0696 48.4017 89.2914 48.937 89.2914 49.4951V71.9444C89.2914 72.5026 89.0696 73.0379 88.6749 73.4326C88.2802 73.8273 87.7449 74.049 87.1867 74.049Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1377 67.5452V53.8945C76.1377 53.7313 76.1698 53.5698 76.2322 53.4191C76.2947 53.2684 76.3862 53.1314 76.5015 53.0161C76.6169 52.9007 76.7538 52.8092 76.9045 52.7468C77.0553 52.6843 77.2168 52.6522 77.3799 52.6522H82.7876C82.9507 52.6522 83.1123 52.6843 83.263 52.7468C83.4137 52.8092 83.5507 52.9007 83.666 53.0161C83.7814 53.1314 83.8729 53.2684 83.9353 53.4191C83.9977 53.5698 84.0299 53.7313 84.0299 53.8945V67.5452C84.0299 67.7084 83.9977 67.8699 83.9353 68.0206C83.8729 68.1714 83.7814 68.3083 83.666 68.4237C83.5507 68.539 83.4137 68.6305 83.263 68.693C83.1123 68.7554 82.9507 68.7875 82.7876 68.7875H77.3799C77.2168 68.7875 77.0553 68.7554 76.9045 68.693C76.7538 68.6305 76.6169 68.539 76.5015 68.4237C76.3862 68.3083 76.2947 68.1714 76.2322 68.0206C76.1698 67.8699 76.1377 67.7084 76.1377 67.5452Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7559 54.7906H62.1069",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7559 62.2765H70.2041",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7559 67.7692H70.2041",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicCoronary);
export default __webpack_public_path__ + "static/media/dynamic_coronary.122d5a59ae7f74d6aa80b88044eec095.svg";
export { ForwardRef as ReactComponent };